import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { isSuperAdmin } from '../lib/roles';
import { Gallery } from './KitGallery';

/**
 * In-app UI kit gallery for platform super-admins (Dev Tools → Components).
 * Demo <Link>s are intercepted so they do not leave this page.
 */
export default function KitGalleryPage() {
  const user = useAuthStore((s) => s.user);
  const navigate = useNavigate();
  const allowed = isSuperAdmin(user);

  useEffect(() => {
    if (user !== null && !isSuperAdmin(user)) {
      navigate('/', { replace: true });
    }
  }, [user, navigate]);

  if (!allowed) return null;

  return (
    <div
      onClickCapture={(e) => {
        const anchor = e.target.closest('a');
        if (!anchor) return;
        const href = anchor.getAttribute('href');
        if (href && href.startsWith('/')) {
          e.preventDefault();
        }
      }}
    >
      <Gallery embedded />
    </div>
  );
}
